import React from 'react'
import { Button, Result } from 'antd'
import { useNavigate } from 'react-router-dom'
import custom404Image from '@/assets/images/404-icon.jpg'

export default function NotFound() {
  const navigate = useNavigate()
  const backHome = () => {
    navigate('/', { replace: true })
  }

  const notFoundStyle = {
    height: '100vh',
    backgroundColor: '#121417',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }

  return (
    <div style={notFoundStyle}>
      <Result
        icon={<img src={custom404Image} alt="404" style={{ maxWidth: '300px' }} />}
        title={<span style={{ color: '#fff' }}></span>}
        subTitle={<span style={{ color: '#515766' }}>Page Not Found</span>}
        extra={
          <Button type="primary" onClick={backHome}>
            回到首页
          </Button>
        }
      />
    </div>
  )
}
